import { LoanTransactionTypeId } from '@/loan/enums/loan-transaction-type-id';

export const LOAN_TRANSACTION_TYPE_MAP: ReadonlyMap<
	LoanTransactionTypeId,
	string
> = new Map<LoanTransactionTypeId, string>([
	[LoanTransactionTypeId.CHARGE_OFF, 'Charge Off'],
	[LoanTransactionTypeId.CPI_PREMIUM, 'CPI Premium'],
	[LoanTransactionTypeId.CPI_PREMIUM_REFUND, 'CPI Premium Refund'],
	[LoanTransactionTypeId.DISBURSEMENT, 'Disbursement'],
	[LoanTransactionTypeId.INSURANCE_PREMIUM, 'Insurance Premium'],
	[LoanTransactionTypeId.INTEREST_CORRECTION, 'Interest Correction'],
	[LoanTransactionTypeId.PAYMENT, 'Payment'],
	[LoanTransactionTypeId.PRINCIPAL_DECREASE, 'Principal Descrease'],
	[LoanTransactionTypeId.PRINCIPAL_INCREASE, 'Principal Increase'],
	[LoanTransactionTypeId.REFUND, 'Refund'],
	[LoanTransactionTypeId.SCRA_INTEREST_REFUND, 'SCRA Interest Refund'],
	[LoanTransactionTypeId.TAKE_BACK, 'Take-Back'],
	[LoanTransactionTypeId.RECOVERY, 'Recovery'],
	[LoanTransactionTypeId.PAYMENT_REFUND, 'Payment Refund'],
]);
